module.exports = __webpack_public_path__ + "media/images/minshi-selfie-6541fa958331bbbed950610680910278.png";